@if (showReadout) {
    <wdx-form-field
        [label]="formInputData?.label | translateTokenisedString"
        [isRequired]="formInputData?.isRequired"
        [isSensitive]="formInputData?.isSensitive"
        [guidanceText]="formInputData?.guidanceText | translateTokenisedString"
        [formInputData]="formInputData"
        [validationErrorMessage]="validationErrorMessage"
        [formDisplayMode]="formDisplayMode"
        [value]="value | fn: valueAsString"
    >
        <button
            class="input-group lookup-container form-control p-0"
            (click)="onOpen()"
            role="button"
            [class.pointer]="!formInputData?.isDisabled"
            tabindex="0"
            (blur)="blurred.emit()"
            [modalId]="!formInputData.isDisabled && modalId"
            [disabled]="formInputData.isDisabled"
            [class.is-invalid]="validationErrorMessage"
        >
            <div class="input-group-text border-0">
                <wdx-icon [icon]="UTILS_ICON_SEARCH"></wdx-icon>
            </div>
            <div
                class="flex-1 form-control border-0 lookup-button"
                [attr.data-cy]="
                    'action-' + (formInputData.name || formInputData.id)
                "
            >
                @if ((!isMulti && value) || (isMulti && value?.length)) {
                    <div class="results-container">
                        @for (
                            infoCardData of value
                                | fn: lookupResultsAsInfoCardData;
                            track $index;
                            let i = $index;
                            let last = $last
                        ) {
                            <wdx-info-card
                                class="result-card text-truncate flush"
                            >
                                @if (infoCardData.avatars?.length) {
                                    <div wdxInfoCardLeading>
                                        <molecule-avatar-group-container
                                            size="sm"
                                            [avatars]="infoCardData.avatars"
                                        ></molecule-avatar-group-container>
                                    </div>
                                }
                                <div wdxInfoCardLabel>
                                    <span
                                        >{{
                                            infoCardData.primaryInfo
                                                | translateTokenisedString
                                        }}
                                    </span>
                                    @if (infoCardData.tertiaryInfo?.length) {
                                        <small class="text-muted">
                                            @for (
                                                item of infoCardData.tertiaryInfo;
                                                track $index;
                                                let last = $last
                                            ) {
                                                ({{
                                                    item.label
                                                        | translateTokenisedString
                                                }})
                                                @if (!last) {
                                                    &nbsp;&middot;&nbsp;
                                                }
                                            }
                                        </small>
                                    }
                                </div>
                                @if (!formInputData.isDisabled) {
                                    <div wdxInfoCardTrailing>
                                        <button
                                            class="custom-actions"
                                            wdxIconButton
                                            [wdxButton]="WdxButtonStyle.None"
                                            [wdxButtonSize]="WdxButtonSize.Sm"
                                            (click)="
                                                isMulti
                                                    ? deleteSingle(
                                                          $event,
                                                          infoCardData.data
                                                      )
                                                    : clearField($event)
                                            "
                                        >
                                            <wdx-icon
                                                [icon]="UTILS_ICON_DELETE"
                                            ></wdx-icon>
                                        </button>
                                    </div>
                                }
                            </wdx-info-card>
                            @if (!last) {
                                <div class="divider-end divider--short"></div>
                            }
                        }
                    </div>
                } @else {
                    @if (placeholder) {
                        <span class="placeholder">
                            {{ placeholder }}
                        </span>
                    }
                }
            </div>
        </button>
    </wdx-form-field>
}

<atom-modal-wrapper [modalId]="modalId" [modalTemplate]="lookupModal">
    <ng-template #lookupModal>
        <organism-modal
            [modalTitle]="formInputData.label | translateTokenisedString"
            (modalClosed)="onClose()"
        >
            <molecule-info-card-search
                [formInputData]="formInputData"
                [mode]="
                    isMulti
                        ? InfoCardSearchMode.MultiSelect
                        : InfoCardSearchMode.Select
                "
                [lookupMode]="lookupMode"
                [infoCards]="lookupResults | fn: lookupResultsAsInfoCardData"
                [isLoading]="lookupIsLoading"
                [hasError]="lookupHasError"
                [initialValue]="value"
                [bannerInfo]="bannerInfo | translateTokenisedString"
                [placeholder]="placeholder"
                [formData]="formData"
                (confirm)="onConfirmClicked()"
                (searchTriggered)="onSearch($event)"
                (generateDocument)="onGenerateAndDownloadDocument($event)"
                (previewAvailableDocumentData)="
                    onPreviewAvailableDocumentData($event)
                "
                (valueChanged)="onChange($event)"
            >
                @if (
                    showNoResultsMessage &&
                    lookupResults?.length === 0 &&
                    keyword
                ) {
                    <div
                        class="flex-shrink-0 flex-grow-0 bg-muted offcanvas-body d-flex align-items-center"
                    >
                        <p>
                            The user does not exist or does not have access to
                            view this record.
                        </p>
                    </div>
                }
            </molecule-info-card-search>
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
